import i18n from "../i18n";

export const confirmMessages = {
  title: i18n.t("Confirm"),
  message: i18n.t(
    "You moved your own activity. Would you like to save the new position to the server?"
  ),
};
export const nothingSelectedMessage = i18n.t(
  "Please select an object first, then press this button to delete the selected object."
);
export const cantDeleteMessage = i18n.t(
  "This object can't be deleted."
);
export const cantInsertMessage = i18n.t(
  "This object can't be inserted."
);

export const ANS_OPTIONS = ["A", "B", "C", "D", "E", "F", "G"];

export const quillModules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ color: [] }, { background: [] }],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    [{ script: "sub" }, { script: "super" }], // superscript/subscript
    ["link", "image", "video", "formula"],
    [{ align: [] }],
    ["clean"],
  ],
};

export const quillFormats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "color",
  "script",
  "align",
  "background",
  "video",
  "formula",
];
